export default __webpack_public_path__ + "static/media/TH.6b6f3849.svg";